import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { StorageConstants } from 'common/constants/app.constant';
import { NavDataHistory } from 'common/models/utilitymodels/base.model';
import { EncryptionDecryption } from 'common/utils/encrdecr.utility';

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    constructor(private storage: Storage) {}

    createStorage() {
        this.storage.create();
    }

    async getAllKeys() {
        return await this.storage.keys();
    }

    stringify(obj: any) {
        let cache: any = [];
        let str = JSON.stringify(obj, function (key, value) {
            if (typeof value === 'object' && value !== null) {
                if (cache.indexOf(value) !== -1) {
                    return;
                }
                cache.push(value);
            }
            return value;
        });
        cache = null;
        return str;
    }

    async setStorage(key: string, value: NavDataHistory) {
        return new Promise((resolve, reject) => {
            this.storage
                .set(key, this.encryptData(value))
                .then((data) => {
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    getStorage(key: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.storage
                .get(key)
                .then((data) => {
                    const parseData: any = data ? this.decryptData(data) : null;
                    resolve(JSON.parse(parseData));
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    removeStorageItem(key: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.storage
                .remove(key)
                .then((data) => {
                    resolve('data removed succesfully');
                })
                .catch((err) => {
                    reject('remove Item SuccesFully');
                });
        });
    }

    async clearStorage() {
        sessionStorage.removeItem(StorageConstants.lastNavigatedUrl);
        this.storage.clear();
    }

    pushKeysToStorage(key: string) {
        const keyList = sessionStorage.getItem(StorageConstants.lastNavigatedUrl);
        if (keyList) {
            const parsed = JSON.parse(keyList);
            parsed.push(key);
            sessionStorage.setItem(StorageConstants.lastNavigatedUrl, JSON.stringify(parsed));
        } else {
            sessionStorage.setItem(StorageConstants.lastNavigatedUrl, JSON.stringify([key]));
        }
    }

    getLastKeyAndDeletefromStorage() {
        const keyList = sessionStorage.getItem(StorageConstants.lastNavigatedUrl);

        if (keyList) {
            const parsed = JSON.parse(keyList);
            const popped = parsed.pop();
            sessionStorage.setItem(StorageConstants.lastNavigatedUrl, JSON.stringify(parsed));
            return popped;
        } else {
            return null;
        }
    }

    encryptData(data: any) {
        const encrypted = new EncryptionDecryption().encrypt(data);
        return encrypted;
    }

    decryptData(data: any) {
        const decrypted = new EncryptionDecryption().decrypt(data);
        return decrypted;
    }
}
